module.exports = __webpack_public_path__ + "fonts/memnYaGs126MiZpBA-UFUKW-U9hoIqOjjg.6d5b82b1.woff2";